
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component
export default class NavbarItem extends Vue {
	@Action('toggleMobileNav', { namespace: 'ui' }) private toggleMobileNav!: (isOpen: boolean) => void;
	@Prop({ type: Object, required: true }) private item!: NavbarItemSettings;

	/**
	 * Determines if the item should be displayed based on its condition.
	 *
	 * @return {boolean}
	 */
	private get showItem(): boolean {
		return !this.item.hidden;
	}

	/**
	 * Toggle mobile nav state and call item's onclick if it exists
	 *
	 * @return {void}
	 */
	private handleOnClick(): void {
		this.toggleMobileNav(false);
		this.item.onClick?.();
	}
}
